import { render } from "./KibanaIframe.vue?vue&type=template&id=7ff66752&scoped=true"
import script from "./KibanaIframe.vue?vue&type=script&lang=js"
export * from "./KibanaIframe.vue?vue&type=script&lang=js"

import "./KibanaIframe.vue?vue&type=style&index=0&id=7ff66752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff66752"]])

export default __exports__